import React, { useState } from "react";
import axiosInstance from "../../../utils/axiosInstance";
import {
  Box,
  Typography,
  TextField,
  Button,
  Alert,
  Grid,
  Paper,
  Stack,
  useTheme,
} from "@mui/material";

export default function EditImproveQuestion({
  selectedItem,
  onSave,
  onCancel,
  chatbotId,
  permission,
}) {
  const [editedItem, setEditedItem] = useState({ ...selectedItem });
  const [error, setError] = useState(null);
  const theme = useTheme();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedItem({ ...editedItem, [name]: value });
  };

  const handleSave = async () => {
    try {
      const params = chatbotId ? { chatbot_id: chatbotId } : {};
      await axiosInstance.put(
        `/edit-improve-question/${editedItem.id}`,
        editedItem,
        { params }
      );

      setError("Data has been saved successfully.");
      onSave();
    } catch (error) {
      console.error("Error updating data:", error);
      setError("Error updating data. Please try again.");
    }
  };

  return (
    <Paper
      elevation={3}
      sx={{
        p: 4,
        mb: 4,
        borderRadius: 3,
        backgroundColor: theme.palette.background.paper,
      }}
    >
      <Typography variant="h6" fontWeight="bold" gutterBottom color="textPrimary">
        Edit Improve Question
      </Typography>

      <Grid container spacing={3}>
        {/* User Question */}
        <Grid item xs={12} md={4}>
          <Typography variant="subtitle1" gutterBottom color="textPrimary">
            User Question
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={6}
            name="questions"
            value={editedItem.questions || ""}
            onChange={handleInputChange}
            variant="outlined"
            placeholder="Enter user question"
          />
        </Grid>

        {/* Bot Answer */}
        <Grid item xs={12} md={4}>
          <Typography variant="subtitle1" gutterBottom color="textPrimary">
            Bot Answer
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={6}
            name="answers"
            value={editedItem.answers || ""}
            onChange={handleInputChange}
            variant="outlined"
            placeholder="Enter bot answer"
          />
        </Grid>

        {/* Improved Question */}
        <Grid item xs={12} md={4}>
          <Typography variant="subtitle1" gutterBottom color="textPrimary">
            Improve Your Question
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={6}
            name="question_improvement"
            value={editedItem.question_improvement || ""}
            onChange={handleInputChange}
            variant="outlined"
            placeholder="Enter improved question"
          />
        </Grid>
      </Grid>

      {permission.canModify && (
        <Box mt={4}>
          <Stack direction="row" spacing={2}>
            <Button variant="contained" color="primary" onClick={handleSave}>
              Save
            </Button>
            <Button variant="outlined" color="secondary" onClick={onCancel}>
              Cancel
            </Button>
          </Stack>
        </Box>
      )}

      {error && (
        <Box mt={3}>
          <Alert severity={error.includes("successfully") ? "success" : "error"}>
            {error}
          </Alert>
        </Box>
      )}
    </Paper>
  );
}
